import Service from '../../services';

const state = {

    allTags: [],
    allAwardTags: [],
};

const getters = {

};

const actions = {

    onGetAllTags({ commit }) {
        return Service.tag.getAllTags().then(res => {
            // if (res.status === 200) {
            //     commit('setAllTags', res.data);
            // }
            return res;
        });
    },

    onAddNewTag({ commit }, data) {
        return Service.tag.addNewTag(data).then(res => {
           if (res.status === 200) {
               alert('Tag has been added!');
               return true;
           } else if (res.status === 409) {
               alert('Tag already exist!');
               return false;
           } else {
               alert('Failed to add new tag with some problem.');
               return false;
           }
        });
    },

    onTaggingPortfolio({ commit }, data) {
        return Service.tag.taggingPortfolio(data);
    }

};

const mutations = {
    setAllTags(state, data) {
        data.forEach(tag => {
            if (tag.type == 0) {
                state.allTags.push(tag);
            } else if (tag.type == 1) {
                state.allAwardTags.push(tag);
            }
        });
    }

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
